export const dismissAllNotifications = 'dismissAllNotifications'
export const pollNotifications = 'pollNotifications'
export const fetchNotifications = 'fetchNotifications'
export const fetchTags = 'fetchTags'
export const createTag = 'createTag'
export const deleteTag = 'deleteTag'
export const archiveTag = 'archiveTag'
export const restoreTag = 'restoreTag'
export const updateTagShare = 'updateTagShare'
export const updateTag = 'updateTag'
export const updateRubricItem = 'updateRubricItem'
export const addTagToComment = 'addTagToComment'
export const removeTagFromComment = 'removeTagFromComment'
export const addScoreToComment = 'addScoreToComment'
export const removeScoreFromComment = 'removeScoreFromComment'
export const setMostRecentNotification = 'setMostRecentNotification'
export const leaveFolder = 'leaveFolder'
export const deleteFolder = 'deleteFolder'

export const shareFolderWithUser = 'shareFolderWithUser'
export const shareFolderWithTeam = 'shareFolderWithTeam'
export const unshareFolderWithUser = 'unshareFolderWithUser'
export const unshareFolderWithTeam = 'unshareFolderWithTeam'

export const generalErrorHandler = 'generalErrorHandler'

export const isAuthenticated = 'isAuthenticated'
export const fetchUser = isAuthenticated
export const logout = 'logout'
export const login = 'login'
export const fetchVideoByID = 'fetchVideoByID'
export const fetchVideoBySlug = 'fetchVideoBySlug'

export const updateUser = 'updateUser'

export const joinTeam = 'joinTeam'
export const leaveTeam = 'leaveTeam'

export const socialConnect = 'socialConnect'
export const socialDisconnect = 'socialDisconnect'
export const socialAuth = 'socialAuth'
export const socialLogin = 'socialLogin'
export const socialSignup = 'socialSignup'
export const fetchSocialAccountConnections = 'fetchSocialAccountConnections'

export const invalidOAuthState = 'invalidOAuthState'

export const resendEmailConfirmation = 'resendEmailConfirmation'

export const passwordReset = 'passwordReset'

export const createEventCF = 'createEventCF'



// WEBPACK FOOTER //
// ./src/actionTypes.js